import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './textEditor.scss';

// Custom toolbar options (no 'image')
const modules = {
    toolbar: [
        [{ header: [1, 2,  false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        // [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ['link'], // Removed 'image'
        ['clean'],
    ],
};

const TextEditor = ({ onSend, content, setContent }) => {
    //   const [content, setContent] = useState('');

    const handleSend = () => {
        // onSend(content);
        console.log(content);
    };

    return (
        <div className='mb-3'>
            <ReactQuill
                value={content}
                onChange={setContent}
                modules={modules}
                theme="snow"
                className="custom-editor"
            />
            {/* <button onClick={handleSend} style={{ marginTop: '1rem' }}>
                Send Email
            </button> */}
        </div>
    );
};

export default TextEditor;
